import BaseHistoryRecordModel from '../BaseHistoryRecordModel';
import { HistoryRecordDto } from '../../services/types';

export default class UserHistoryRecordModel extends BaseHistoryRecordModel {
    constructor(data: HistoryRecordDto) {
        super(data);

        const userName = this.fields.find(field => field.name === 'UserName')?.value;

        if (typeof userName === 'string') {
            this.setDisplayName(userName);
        }
    }

    get objectLabel() {
        return 'User';
    }
}
